import { OktaAuthOptions } from '@okta/okta-auth-js';
import { getEnv, getEnvVar, getOrigin } from '@datavant/idsb-shared/utils/browserEnvironmentVariables';

const envConfig = getEnvVar(getEnv(), 'idsbPortalOkta');

// The env bucket's `redirectUri`/`postLogoutRedirectUri` are hardcoded to the canonical
// host for the environment (e.g. https://idsb-portal.datavant-staging.com). Ephemeral
// environments are served from idsb-portal-<suffix>.datavant-staging.com, which getEnv()
// classifies as `staging`, so they would otherwise inherit the canonical staging host.
// That host is cross-origin to the ephemeral page, so the silent token autoRenew (a hidden
// iframe) never posts its result back and the app hangs on "Loading..." forever after the
// token expires. Deriving the callback URLs from the actual origin keeps them same-origin in
// every environment (identical to the hardcoded value on the canonical staging/prod hosts).
// getOrigin() is empty during SSR, where we fall back to the env bucket's absolute URLs.
const origin = getOrigin();

export const config: OktaAuthOptions = {
    ...envConfig,
    ...(origin
        ? {
              redirectUri: `${origin}/cb`,
              postLogoutRedirectUri: `${origin}/login`,
          }
        : {}),
};
